// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const SchoolModel = require("./models/school").default

export default {
  start() {
    const school = new SchoolModel(bootstrappedData.school)
    window.App.version = school.get("platform_version")
    window.App.school = school
  }
}
